import Tabs, { Tab } from '@/components/ui/tabs';
import { useAuthentication } from '@/hooks/useAuthentication';
import { useEffect, useState } from 'react';
import { useAdminStore } from '../../store/useAdmin.store';
import { useNavigate } from 'react-router-dom';

export enum AdminTabsEnum {
  SchoolManagement = 'Admin Management',
  SchoolDashboard = 'Reporting Dashboard',
  SurveyDashboard = 'Survey Dashboard',
  Announcements = 'Announcements',
}

export const AdminTabs = ({ activeTab }: { activeTab: AdminTabsEnum }) => {
  const { authentication } = useAuthentication();
  const { page } = useAdminStore();
  const navigate = useNavigate();

  const [tabs, setTabs] = useState<Tab[]>([
    {
      name: page?.schoolManagement.tabs?.adminManagementTabName || 'Admin Management',
      href: '/school-management',
      current: activeTab === (page?.schoolManagement.tabs?.adminManagementTabName || 'Admin Management'),
    },
    {
      name: page?.schoolManagement.tabs?.reportingDashboardTabName || 'Reporting Dashboard',
      href: '/dashboard',
      current: activeTab === (page?.schoolManagement.tabs?.reportingDashboardTabName || 'Reporting Dashboard'),
    },
    {
      name: page?.schoolManagement.tabs?.surveyDashboardTabName || 'Survey Dashboard',
      href: '/survey-dashboard',
      onClick: () => {},
      current: activeTab === (page?.schoolManagement.tabs?.surveyDashboardTabName || 'Survey Dashboard'),
    },
    {
      name: page?.schoolManagement.tabs?.announcementsTabName || 'Announcements',
      href: '/announcements',
      onClick: () => {},
      current: activeTab === (page?.schoolManagement.tabs?.announcementsTabName || 'Announcements'),
    },
  ]);

  useEffect(() => {
    if (!authentication || !authentication.user) {
      return;
    }

    if (!authentication.user.ws_permission) {
      return navigate('/not-authorized');
    }

    if (!authentication.user.ws_permission.adminManagement) {
      tabs.splice(0, 1);
    }
    if (!authentication.user.ws_permission.reportingDashboard) {
      tabs.splice(1, 1);
    }
    if (!authentication.user.ws_permission.surveyDashboard) {
      tabs.splice(2, 1);
    }
    if (!authentication.user.ws_permission.announcements) {
      tabs.splice(3, 1);
    }

    setTabs([...tabs]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authentication]);
  return (
    <div className=" flex w-full justify-center">
      <Tabs tabs={tabs} setTabs={() => {}} />
    </div>
  );
};
